import { useEffect } from 'react'
import { useAuth0 } from '@auth0/auth0-react'

export default function AuthRedirect() {
  const { loginWithRedirect } = useAuth0()

  useEffect(() => {
    if (typeof window === 'undefined') {
      return
    }

    // Explicitly set redirectUri to current origin to ensure localhost works
    const currentOrigin = window.location.origin
    loginWithRedirect({
      redirectUri: currentOrigin,
      appState: {
        returnTo: currentOrigin,
      },
    })
  }, [loginWithRedirect])

  return null
}
